window.clearSelect = function(elm, find = '', callback = null)
{
    let clear = {
        init: function(select, callback = null) {
            let option = {};
            $(select).each(function(i) {
                $(this).empty();
                // select2クリア
                if ($(this).hasClass('select2')) {
                    option.width = "100%";
                    option.data = [{'id': '', 'text': '-----'}];
                    option.val = '';
                    // modal内の時は親modal要素をdropdownParent指定する
                    let parent = $(this).parents('.modal-content');
                    if (parent.length > 0) {
                        option.dropdownParent = parent;
                    }
                    $(this).select2(option);
                }
                // multi-selectクリア
                if ($(this).hasClass('multi-select')) {
                    $(this).multipleSelect('refreshOptions', {filter: false});
                    $(this).multipleSelect('setSelects', []);
                }
                // tree-multi-selectクリア
                if ($(this).hasClass('tree-multi-select')) {
                    let name = $(this).attr('name');
                    if (name in treeMultiSelects) {
                        treeMultiSelects[name][0].remove();
                        treeMultiSelects[name][0].reload();
                    }
                }
                if (callback != null) {
                    callback(elm, option);
                }
            });
        }
    }
    // 指定選択肢をクリア
    let select = $(elm).parents('form').find(find);
    if (select.length > 0) {
        clear.init(select, callback);
    }
    // 営業所に紐づく選択肢は全てクリアする
    if (find !== 'select.section-select' && find !== '') {
        return;
    }
    selects = [
        'select.account-user-select',
        'select.user-select',
        'select.driver-select',
        'select.rollcall-assistant-select',
        'select.rollcall-enforcer-select',
        'select.rollcall-authorizer-select',
        'select.rollcall-remote_rolrecognizedlcall-select',
        'select.rollcall-general-select',
        'select.maintenance-manager-select',
        'select.maintenance-assistant-select',
        'select.maintenance-manager-and-assistant-select',
        'select.employment-select',
        'select.occupation-select',
        'select.post-select',
        'select.department-select',
        'select.vehicle-select',
        'select.vehicle_serial-select',
        'select.inspection_type-select',
        'select.request_destination-select',
        'select[name="vehicle_equipment_id"]',
        'select.vehicle_classification-select',
        'select[name="guidance_kind_id"]',
        'select[name="belongings"]',
        'select[name="consignor_id"]',
        'select.set-section-select-option',
        'select[name="shipper_id"]',
        'select[name="group_vehicles[]"]',
        'select[name="send_user_groups[]"]',
        'select.category-select',
        'select.unit-select',
    ];
    selects.forEach(function(value){
        let select = $(elm).parents('form').find(value);
        if (select.length > 0) {
            clear.init(select);
        }
    });
}

// 送信するデータを作成する
window.setSendData = function(datas, elm, find)
{
    let select = $(elm).parents('form').find(find);
    if (select.length > 0) {
        const exclude = [
            'with_trashed', 'exclude', 'excludeStatuses'
        ];
        const include = [
            'include'
        ];
        // 変更対象のexclude・includeのdata属性を加える
        $.each($(select).data(), function(key, val) {
            if (exclude.indexOf(key) !== -1) {
                datas[key] = val;
            }
            if (include.indexOf(key) !== -1) {
                datas[key] = val;
            }
        });
        // トリガーとなるセレクトがholding,company,sectionのセレクトの場合はその値を追加する
        $.each(['holding', 'company', 'section'], function(key, val) {
            if ($(elm).hasClass(val + '-select')) {
                datas[val + '_id'] = $(elm).val();
            }
        });
        // マスタと異なるの表示名のグループ会社・会社・営業所選択ボックスを変更したとき
        if (find == 'select.holding-select' || find == 'select.company-select' || find == 'select.section-select' || find == 'select.implement-section-select') {
            let target = $(elm).parents('form').find(find);
            datas['display_id'] = $(target).data('display_id');
            datas['display_name'] = $(target).data('display_name');
        }
        // account-user-selectの場合は選択中の値を追加する
        if (find === 'select.account-user-select') {
            datas.selected = $(select).val();
        }
        // vehicle-selectもしくはcompany-vehicle-selectで「廃車を含む」チェックボックス要素が存在・チェックがあれば、excludeStatusesにマージ
        if (find === 'select.vehicle-select' || find === 'select.company-vehicle-select') {
            let flgElm = $(select).prevAll('.include-scrap-vehicle-flg').find('input[name=include_scrap_vehicle_flg]');
            if (flgElm.length) {
                let scrapStatus = flgElm.data('scrap_status');
                if (!flgElm.prop('checked')) {
                    // 廃車を含まない = 除外ステータスを追加
                    if (datas['excludeStatuses']) {
                        datas['excludeStatuses'] = datas['excludeStatuses'] + ',' + scrapStatus;
                    } else {
                        datas['excludeStatuses'] = scrapStatus;
                    }
                }
            }
        }
    }
    return datas;
}

// セレクトの値をセットする
window.setSelect = function(elm, find, datas = {}, callback = null)
{
    let select = $(elm).parents('form').find(find);

    // (*-)company-xxx-selectで「営業所で絞込み」チェックボックス要素が存在・チェックがあればクリアで終了
    if (find.match(/^select\.(|.*\-)company\-.*\-select$/i) !== null) {
        let filter = select.prevAll('.select-filter-section').find('input[name^="select_filter_section_"]');
        let section = select.parents('form').find('select.section-select');
        if (section.length > 0 && filter.length > 0 && filter.prop('checked')) {
            if (section.val() === '') {
                clearSelect(elm, find);
                return;
            }
        }
    }

    // multi-select 設定の時は、setMultiSelect
    if (select.hasClass('multi-select')) {
        setMultiSelect(elm, find, datas, callback);
        return;
    }
    // tree-multi-select 設定の時は、setTreeMultiSelect
    if (select.hasClass('tree-multi-select')) {
        setTreeMultiSelect(elm, find, datas, callback);
        return;
    }
    if (select.length == 0) {
        select = $(elm).parents('.dummy-form-for-set-select').find(find);
    }
    if (select.length > 0) {
        let action = $(select).data('action');
        let value = $(select).val();
        datas = setSendData(datas, elm, find);
        _ajax.post(action, datas, function (results) {
            $(select).each(function(i) {
                $(this).empty();
                // 変更前の名前が存在する場合
                if ($(this).is('[data-original_name]') && $(this).data('original_name') !== '') {
                    let own = $(this);
                    results.options.forEach(function(item) {
                        if (item.id === own.data('default-id')) {
                            item.text = own.data('original_name');
                        }
                    });
                }
                let option = {
                    width: "100%",
                    data: results.options,
                    val: value
                };
                // modal内の時は親modal要素をdropdownParent指定する
                let parent = $(this).parents('.modal-content');
                if (parent.length > 0) {
                    option.dropdownParent = parent;
                }

                $(select).select2(option);

                // 配車版・経由地
                if (find == 'select[name^="via_points"][name$="[via_point_id]"]') {
                    let templ = $('select[name="via_points[][via_point_id]"]');
                    if (templ.length > 0) {
                        templ.select2(option);
                    }

                    if (select.length > 1) {
                        select.each(function() {
                            let val = window.viaPointsMap.get($(this).attr('name'));
                            if (val) {
                                $(this).val(val).trigger('change');
                            }
                        });
                    }
                } else {
                    $(select).val(value).trigger('change');
                }

                if (value && value.length) {
                    if ($(this).find('option[value="' + value + '"]').length > 0) {
                        $(this).val(value).trigger('change');
                    } else {
                        $(this).val('').trigger('change');
                    }
                }
                if (callback != null) {
                    callback(elm, option);
                }
            });
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    }
}

// セレクトの値をセットする
window.setMultiSelect = function(elm, find, datas = {}, callback = null)
{
    let select = $(elm).parents('form').find(find);
    datas.multi = true;
    if (select.length > 0) {
        let action = $(select).data('action');
        let value = $(select).val();
        datas = setSendData(datas, elm, find);
        _ajax.post(action, datas, function (results) {
            $(select).empty();
            $.each(results.options, function(index, option) {
                $(select).append($('<option></option>', {
                    'value': option.id
                }).text(option.text));
            })
            if (!select.is('filter') || select.data('filter') === false) {
                $(select).multipleSelect('refreshOptions', {
                    filter: false
                });
            }
            $(select).multipleSelect('setSelects', []);
            if (callback != null) {
                callback(elm, select, value);
            }
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    }
}

// セレクトの選択値をセットする
window.setMultiSelected = function(elm, find, datas = {})
{
    let select = $(elm).parents('form').find(find);
    datas.multi = true;
    if (select.length > 0) {
        let action = $(select).data('selected-action');
        _ajax.post(action, datas, function (results) {
            if (results.value != null) {
                $(select).multipleSelect('setSelects', results.value);
            } else {
                $(select).multipleSelect('setSelects', []);
            }
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    }
}

// ツリーセレクトの値をセットする
window.setTreeMultiSelect = function(elm, find, datas = {}, callback = null)
{
    let select = $(elm).parents('form').find(find);
    if (select.length > 0) {
        let action = $(select).data('action');
        let name = $(select).attr('name');
        let option = {
            searchable: true,
            enableSelectAll: true,
            sortable: true,
            startCollapsed: false,
            sectionDelimiter: ": ",
            hideSidePanel: true,
        };
        if ($(select).data('search_text')) {
            option.searchText = $(select).data('search_text');
        }
        if ($(select).data('select_all_text')) {
            option.selectAllText = $(select).data('select_all_text');
        }
        if ($(select).data('unselect_all_text')) {
            option.unselectAllText = $(select).data('unselect_all_text');
        }
        if ($(select).is('[data-hide_side_panel]') && $(select).data('hide_side_panel') !== 1) {
            // サイドパネルを表示する
            option.hideSidePanel = false;
        }
        if ($(select).is('[data-freeze]') && $(select).data('freeze') === 1) {
            // freeze：オプションの選択/選択解除を無効にするか
            // デフォルト：false（true：表示のみ）
            option.freeze = true;
            option.searchable = false;
            option.enableSelectAll = false;
            option.sortable = false;
        }
        datas = setSendData(datas, elm, find);
        // selectedにするidのuser_setting_keyがあれば取得
        if ($(select).data('user_setting_key')) {
            datas['user_setting_key'] = $(select).data('user_setting_key');
        }
        _ajax.post(action, datas, function (results) {
            $(select).empty();
            $.each(results.options, function(index, item) {
                $(select).append($('<option></option>', {
                    'value': item.value,
                    'data-section': item.section,
                    'data-index': item.idx,
                    'selected': typeof item.selected !== 'undefined' && item.selected
                }).text(item.text));
            });
            if (!(name in treeMultiSelects)) {
                treeMultiSelects[name] = $(select).treeMultiselect(option);
            }
            treeMultiSelects[name][0].remove();
            treeMultiSelects[name][0].reload();

            if (callback != null) {
                callback(elm);
            }
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    }
}

// チェックボックスの値をセットする
window.setOccupationCheckbox = function(elm, datas = {})
{
    let checkbox = $(elm).parents('form').find('.occupation-check');
    if (checkbox.length > 0) {
        let action = $(checkbox).data('action');
        _ajax.post(action, datas, function (results) {
            let index = results.options.findIndex((v) => v.id == '');
            if (index == 0) {
                results.options.splice(index, 1);
            }
            $(checkbox).children('div:not(.copy,.occupation-check-not-found)').remove();
            if (results.options.length > 0) {
                $.each(results.options, function(index, option) {
                    let clone = $(checkbox).find('.copy').clone();
                    let input = $(clone).find('input');
                    let label = $(clone).find('label');
                    let id = $(input).attr('id') + option.id;
                    $(input).attr('id', id);
                    $(input).val(option.id);
                    $(input).data('occupation-type', option.type);
                    $(label).attr('for', id);
                    $(label).text(option.text);
                    $(clone).removeClass('copy').removeClass('display-none');
                    $(checkbox).append($(clone));
                });
                $(checkbox).find('.occupation-check-not-found').addClass('display-none');
            } else {
                $(checkbox).find('.occupation-check-not-found').removeClass('display-none');
            }
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    }
}

// セレクトの値をセットする
window.viaPointsMap = new Map();
window.setViaPointsSelect = function(elm, datas = {}) {
    window.viaPointsMap = new Map();
    let select = $(elm).parents('form').find('select[name^="via_points"][name$="[via_point_id]"]');
    if (select.length > 1) {
        select.each(function() {
            window.viaPointsMap.set($(this).attr('name'), $(this).val());
        });
    }
}

// ユーザーとドライバーのセレクト設定時の共通処置
window.commonUserSelectedEvent = function(elm)
{
    let sectionSelect = $(elm).parents('form').find('.section-select');
    let searchSections = $(elm).parents('form').find('input[name="search_section_ids"]');
    let datas = {};
    if (sectionSelect.length > 0) {
        datas.user_id = $(elm).val();
        datas.section_id = $(sectionSelect).val();
    }
    // 検索用の所属営業所指定があれば、条件セットする
    if (searchSections.length > 0) {
        datas.sectionIds = searchSections.val();
    }
    setSelect(elm, 'select.vehicle-select', datas);
    setSelect(elm, 'select.vehicle_serial-select', datas);
    datas.type = 'authorizer';
    setSelect(elm, 'select.rollcall-authorizer-select', datas);
    setSelect(elm, 'select.rollcall-recognized-select', datas);
}

/**
 * 営業所で絞り込むFLG付きセレクト設定の共通処理
 * @param checkFlg
 * @param callback
 */
window.selectFilterSection = function(checkFlg, callback = null)
{
    let form = $(checkFlg).parents('form');
    let targetName = $(checkFlg).data('target');
    let targetSelect = form.find('select[name="' + targetName + '"]');
    let companySelect = form.find('select.company-select');
    let sectionSelect = form.find('select.section-select');
    let params = {};
    // 引数対象の選択肢がなければ何もしない
    if (targetSelect.length <= 0 || companySelect.length <= 0 || sectionSelect.length <= 0) {
        return;
    }
    // クリア
    clearSelect(targetSelect, 'select[name="' + targetName + '"]');
    // パラメタが必要なものは追加する
    if (targetSelect.hasClass('company-driver-select')) {
        params = {'type': 'driver'};
    } else if (targetSelect.hasClass('rollcall-company-authorizer-select')) {
        params = {'type': 'authorizer'};
    }
    // ONの時は営業所の条件を追加する
    if ($(checkFlg).prop('checked')) {
        // 営業所が選択されていない場合は、取得しない
        if (sectionSelect.find('option:selected').length > 0 && sectionSelect.find('option:selected').val() !== '') {
            params.section_id = sectionSelect.val();
            setSelect(targetSelect, 'select[name="' + targetName + '"]', params);
        } else {
            clearSelect(targetSelect, 'select[name="' + targetName + '"]');
        }
    } else {
        // 会社が選択されていない場合は、選択肢を表示しない
        if (companySelect.find('option:selected').length > 0 && companySelect.find('option:selected').val() !== '') {
            params.company_id = companySelect.val();
            setSelect(targetSelect, 'select[name="' + targetName + '"]', params);
        } else {
            clearSelect(targetSelect, 'select[name="' + targetName + '"]');
        }
    }
}

/**
 * Ajax系セレクトのオプション設定を行う
 */
$(function () {

    /**
     * 項目が増え続けるため、以下class付与で更新処理を実行
     *  (以下、会社選択のセレクトを更新する「set-company-select-option」のサンプル)
     *
     * @uses {{ Form::select('label', 'name', $value, [
     *      'id' => 'オリジナルID',
     *      'class' => 'set-company-select-option オリジナルクラス',
     *      'data-action' => route('オプション取得先ルーティング名')
     * ]) }}
     *
     * パターン：
     * set-holding-select-option ... Gr会社の選択時にオプションを更新
     * set-company-select-option ... 会社の選択時にオプションを更新
     * set-section-select-option ... 営業所の選択時にオプションを更新
     */

    /*---- グループ会社のセレクト設定時 ----*/

    // セレクト設定時
    $(document).on('change', 'select.holding-select', function () {
        setOccupationCheckbox(this);
        setViaPointsSelect(this);
        if ($(this).find('option:selected').length > 0 && $(this).find('option:selected').val() !== '') {
            setSelect(this, 'select.company-select');
            setSelect(this, 'select.contract-select');
            setMultiSelect(this, 'select.group-select');
            setMultiSelect(this, 'select.holding-multiple-select',
                {'exclude': $(this).find('option:selected').val(), 'onPrepend': false, 'fromAccessibleIds': true, 'onPrependCode': true});
            setSelect(this, 'select.vehicle_model-select');
            setSelect(this, 'select.company-driver-select.search-driver', {'type': 'driver'});
            setSelect(this, 'select.set-holding-select-option');
            setTreeMultiSelect(this, 'select[name="vehicle_id[]"]');
            setTreeMultiSelect(this, 'select[name="vehicle_ids[]"]');
            setSelect(this, 'select.category-select');
            setSelect(this, 'select.unit-select');
        } else {
            clearSelect(this, 'select.contract-select');
            clearSelect(this, 'select.company-select');
            clearSelect(this, 'select.section-select');
            clearSelect(this, 'select.implement-section-select');
            clearSelect(this, 'select.company-driver-select');
            clearSelect(this, 'select.request_destination-select');
            clearSelect(this, 'select.set-holding-select-option');
            clearSelect(this, 'select[name="vehicle_id[]"]');
            clearSelect(this, 'select[name="vehicle_ids[]"]');
            // callback処理が必要の為、repair-selectは個別でクリア
            clearSelect(this, 'select.repair-select', function(elm, option) {
                delete option.dropdownParent;
                $('#select-for-clone').text(JSON.stringify(option));
            });
            clearSelect(this, 'select.category-select');
            clearSelect(this, 'select.unit-select');
            clearSelect(this, 'holding-multiple-select', {'onPrepend': false, 'fromAccessibleIds': true, 'onPrependCode': true});

            // 会社driverが検索要素設定の時は、クリア時に全ドライバーリスト取得
            if ($(this).hasClass('search-driver')) {
                setSelect(this, 'select.company-driver-select', {'type': 'driver'});
            }
        }
    });

    /*---- 会社のセレクト設定時 ----*/

    // セレクト設定時
    $(document).on('change', 'select.company-select', function () {
        setOccupationCheckbox(this);
        setViaPointsSelect(this);
        if ($(this).find('option:selected').length > 0 && $(this).find('option:selected').val() !== '') {
            setSelect(this, 'select.contract-select');
            setSelect(this, 'select.section-select', {'section_ids': $(this).parents('form').find('select.section-select').data('section_ids')});
            setSelect(this, 'select.implement-section-select');
            setSelect(this, 'select.notificationsection-select');
            const $checkbox = $('#input-is-driver-only');
            if($checkbox.length !== 0){
                let param = {}
                if($checkbox.prop('checked')){
                    param.type = 'driver';
                }
                setSelect(this, 'select.company-driver-select', param);
            }
            else{
                setSelect(this, 'select.company-driver-select', {'type': 'driver'});
            }
            setSelect(this, 'select.company-vehicle-select');
            setSelect(this, 'select.company-vehicle_serial-select');
            setSelect(this, 'select.rollcall-company-authorizer-select', {'type': 'authorizer'});
            setSelect(this, 'select.company-maintenance-manager-and-assistant-select', {'type': 'maintenance_manager_and_assistant'});
            setSelect(this, 'select[name="loading_point_id"]', {'type': 1});
            setSelect(this, 'select[name="unloading_point_id"]', {'type': 2});
            setSelect(this, 'select[name="delivery_item_id"]');
            setSelect(this, 'select.set-company-select-option');
            setMultiSelect(this, 'select.belonging-multiple-select', {
                'rollcall_type': (
                    ($(this).parents('form').find('input[name="rollcall_type"]:checked').length) ?
                        $(this).parents('form').find('input[name="rollcall_type"]:checked').val() :
                        $(this).parents('form').find('input[name="rollcall_type"]').val()
                ),
                'default_belongings': $(this).parents('form').find('select[name="belongings[]"]').data('default-belongings'),
            }, function(companySelect, select, values) {
                $.each(values, function(i, value) {
                    $(select).multipleSelect('check', value);
                });
            });
            setMultiSelect(this, 'select.sections-select', {'company_id': $(this).val(), 'is_show_empty': false});
            setTreeMultiSelect(this, 'select[name="vehicle_id[]"]');
            setTreeMultiSelect(this, 'select[name="vehicle_ids[]"]');
            setSelect(this, 'select.category-select');
            setSelect(this, 'select.unit-select');
            setSelect(this, 'select[name^="via_points"][name$="[via_point_id]"]');
            setSelect(this, 'select.evaluation-select', {'company_id': $(this).val()});
            setSelect(this, 'select.vehicle_classification_by_company-select');
        } else {
            clearSelect(this, 'select.contract-select');
            clearSelect(this, 'select.section-select');
            clearSelect(this, 'select.implement-section-select');
            clearSelect(this, 'select.notificationsection-select');
            clearSelect(this, 'select.company-driver-select');
            clearSelect(this, 'select.company-vehicle-select');
            clearSelect(this, 'select.company-vehicle_serial-select');
            clearSelect(this, 'select.request_destination-select');
            clearSelect(this, 'select.rollcall-company-authorizer-select');
            clearSelect(this, 'select.company-maintenance-manager-and-assistant-select');
            clearSelect(this, 'select[name="loading_point_id"]');
            clearSelect(this, 'select[name="unloading_point_id"]');
            clearSelect(this, 'select[name="delivery_item_id"]');
            clearSelect(this, 'select.belonging-multiple-select');
            clearSelect(this, 'select.instruction-multiple-select');
            clearSelect(this, 'select.category-select');
            clearSelect(this, 'select.unit-select');
            clearSelect(this, 'select[name^="via_points"][name$="[via_point_id]"]');
            clearSelect(this, 'select.evaluation-select');
            clearSelect(this, 'select.vehicle_classification_by_company-select');

            clearSelect(this, 'select.set-company-select-option');
            // callback処理が必要の為、repair-selectは個別でクリア
            clearSelect(this, 'select.repair-select', function(elm, option) {
                delete option.dropdownParent;
                $('#select-for-clone').text(JSON.stringify(option));
            });
            // 会社driverが検索要素設定、tree車両選択の表示時は、クリア時にholding_idで車両リスト取得
            if ($(this).hasClass('search-driver') || $(this).hasClass('tree-multi-vehicle')) {
                let holding = $('select.holding-select');
                if (holding.find('option:selected').val().length > 0 && holding.find('option:selected').val() !== '') {
                    setSelect(this, 'select.company-driver-select', {'type': 'driver', 'holding_id': holding.find('option:selected').val()});
                    setTreeMultiSelect(this, 'select[name="vehicle_id[]"]', {'holding_id': holding.find('option:selected').val()});
                }
            }
        }
    });

    /*---- 営業所のセレクト設定時 ----*/

    // セレクト設定時
    $(document).on('change', 'select.section-select', function () {
        let sectionId = $(this).find('option:selected').val();
        let form = $(this).parents('form');
        setOccupationCheckbox(this, {'section_id': sectionId});
        if ($(this).find('option:selected').length > 0 && sectionId !== '') {
            setSelect(this, 'select.account-user-select', {'type': 'account'});
            setSelect(this, 'select.user-select');
            const $checkbox = $('#input-is-driver-only');
            if($checkbox.length !== 0){
                let param = {}
                if($checkbox.prop('checked')){
                    param.type = 'driver';
                }
                setSelect(this, 'select.driver-select', param);
            }
            else{
                setSelect(this, 'select.driver-select', {'type': 'driver'});
            }
            setSelect(this, 'select.rollcall-assistant-select', {'type': 'assistant'});
            setSelect(this, 'select.rollcall-enforcer-select', {'type': 'enforcer'});
            setSelect(this, 'select.rollcall-authorizer-select', {'type': 'authorizer'});
            setSelect(this, 'select.rollcall-recognized-select', {'type': 'recognized'});
            setSelect(this, 'select.rollcall-general-select', {'type': 'general'});
            setSelect(this, 'select.maintenance-manager-select', {'type': 'maintenance_manager'});
            setSelect(this, 'select.maintenance-assistant-select', {'type': 'maintenance_assistant'});
            setSelect(this, 'select.maintenance-manager-and-assistant-select', {'type': 'maintenance_manager_and_assistant'});
            setSelect(this, 'select.employment-select');
            setSelect(this, 'select.occupation-select');
            setSelect(this, 'select.set-section-select-option');
            setMultiSelect(this, 'select.occupation-multiple-select', {'section_id': $(this).val()});
            setMultiSelect(this, 'select.vehicle_option-multiple-select', {'section_id': $(this).val()},
            function(sectionSelect, select, values) {
                if (Array.isArray(values) && values.length) {
                    select.multipleSelect('setSelects', values);
                }
            });
            setMultiSelect(this, 'select.instruction-multiple-select', {
                'section_id': sectionId,
                'authorizer_id': form.find('select[name="authorizer_id"]').val(),
                'rollcall_type': (
                    (form.find('input[name="rollcall_type"]:checked').length) ?
                        form.find('input[name="rollcall_type"]:checked').val() :
                        form.find('input[name="rollcall_type"]').val()
                ),
                'user_id': form.find('select[name="user_id"]').val(),
                'default_instructions': form.find('select.instruction-multiple-select').data('default-instructions'),
                'display_type': form.find('select.instruction-multiple-select').data('display-type'),
                'with_trashed': form.find('select.instruction-multiple-select').data('with-trashed')
            }, function(companySelect, select, values) {
                $.each(values, function(i, value) {
                    $(select).multipleSelect('check', value);
                });
            });
            setSelect(this, 'select.post-select');
            setSelect(this, 'select.department-select');
            setSelect(this, 'select.inspection_type-select');
            setSelect(this, 'select.vehicle_classification-select');
            setSelect(this, 'select.vehicle-select');
            setSelect(this, 'select.vehicle_serial-select');
            setSelect(this, 'select.repair-select', {}, function(elm, option){
                delete option.dropdownParent;
                $('#select-for-clone').text(JSON.stringify(option));
            });
            setSelect(this, 'select.request_destination-select');
            setSelect(this, 'select[name="consignor_id"]');
            setSelect(this, 'select[name="shipper_id"]');
            setTreeMultiSelect(this, 'select[name="group_vehicles[]"]', {'section_id': sectionId});
            setTreeMultiSelect(this, 'select[name="send_user_groups[]"]', {'section_id': sectionId});
            setTreeMultiSelect(this, 'select[name="vehicle_id[]"]');
            setTreeMultiSelect(this, 'select[name="vehicle_ids[]"]');
            // 指導記録-指導名
            if ($(this).hasClass('guidance-select')) {
                let checked = $('input[name="guidance_type"]:checked');
                if (checked.length > 0) {
                    let data = {
                        'section_id': sectionId,
                        'guidance_type': checked.val()
                    }
                    setSelect(this, 'select[name="guidance_kind_id"]', data);
                }
            }
        } else {
            clearSelect(this);
            // callback処理が必要の為、repair-selectは個別でクリア
            clearSelect(this, 'select.repair-select', function(elm, option) {
                delete option.dropdownParent;
                $('#select-for-clone').text(JSON.stringify(option));
            });
            // tree車両選択の表示時は、クリア時にcompany_idで車両リスト取得
            if ($(this).hasClass('tree-multi-vehicle')) {
                let company = $('select.company-select');
                if (company.find('option:selected').val().length > 0 && company.find('option:selected').val() !== '') {
                    setTreeMultiSelect(this, 'select[name="vehicle_id[]"]', {'company_id': company.find('option:selected').val()});
                    setTreeMultiSelect(this, 'select[name="vehicle_ids[]"]', {'company_id': company.find('option:selected').val()});
                }
            }
            setMultiSelect(this, 'select.instruction-multiple-select', {
                'section_id': sectionId,
                'authorizer_id': form.find('select[name="authorizer_id"]').val(),
                'rollcall_type': (
                    (form.find('input[name="rollcall_type"]:checked').length) ?
                        form.find('input[name="rollcall_type"]:checked').val() :
                        form.find('input[name="rollcall_type"]').val()
                ),
                'user_id': form.find('select[name="user_id"]').val(),
                'default_instructions': form.find('select.instruction-multiple-select').data('default-instructions'),
                'display_type': form.find('select.instruction-multiple-select').data('display-type'),
                'with_trashed': form.find('select.instruction-multiple-select').data('with-trashed')
            }, function(companySelect, select, values) {
                $.each(values, function(i, value) {
                    $(select).multipleSelect('check', value);
                });
            });
        }

        /*---- 「営業所で絞込み」チェックがONのセレクトの制御 ----*/
        let filters = form.find('input[name^="select_filter_section_"]:checked');
        filters.each(function(n, filter) {
            selectFilterSection(filter);
        });

    });

    /*---- ユーザーのセレクト設定時 ----*/

    // セレクト設定時
    $(document).on('change', 'select.user-select', function () {
        commonUserSelectedEvent(this);
        setMultiSelected(this, 'select.group-select', {'user_id': $(this).val()})
    });

    /*---- ドライバーのセレクト設定時 ----*/

    // セレクト設定時
    $(document).on('change', 'select.driver-select', function () {
        commonUserSelectedEvent(this);
    });

    /*---- 車両のセレクト設定時 ----*/

     // セレクト設定時
    $(document).on('change', 'select.vehicle-select', function () {
        if ($(this).val() !== '') {
            setSelect(this, 'select[name="vehicle_equipment_id"]', {'vehicle_id': $(this).val()});
        } else {
            clearSelect(this, 'select[name="vehicle_equipment_id"]');
        }
    });

     /*---- 「廃車を含む」押下時 ----*/

     // 「廃車を含む」チェックボックス押下
     $(document).on('click', 'input[name=include_scrap_vehicle_flg]', function () {
         // 選択肢変更対象の要素
         let vehicleSelect = $(this).parents('form').find('select.vehicle-select');
         let companyVehicleSelect = $(this).parents('form').find('select.company-vehicle-select');
         if (vehicleSelect.length > 0) {
             // グループ会社セレクト要素
             let holdingSelect = $(this).parents('form').find('select.holding-select');
             // グループ会社が選択されていない初期表示では全選択肢を表示
             if (holdingSelect.find('option:selected').length > 0 && holdingSelect.find('option:selected').val() !== '') {
                 // 営業所セレクト要素
                 let sectionSelect = $(this).parents('form').find('select.section-select');
                 if (sectionSelect.length <= 0) {
                     return;
                 }
                 // グループ会社の設定はあるが、営業所が選択されていない場合は、選択肢を表示しない
                 if (sectionSelect.find('option:selected').length > 0 && sectionSelect.find('option:selected').val() !== '') {
                     setSelect(vehicleSelect, 'select.vehicle-select', { 'section_id': sectionSelect.val() });
                 } else {
                     clearSelect(vehicleSelect, 'select.vehicle-select');
                 }
             } else {
                 setSelect(vehicleSelect, 'select.vehicle-select');
             }
         } else if (companyVehicleSelect.length > 0) {
            // グループ会社セレクト要素
            let holdingSelect = $(this).parents('form').find('select.holding-select');
            // グループ会社が選択されていない初期表示では全選択肢を表示
            if (holdingSelect.find('option:selected').length > 0 && holdingSelect.find('option:selected').val() !== '') {
                // 会社セレクト要素
                let companySelect = $(this).parents('form').find('select.company-select');
                if (companySelect.length <= 0) {
                    return;
                }
                // グループ会社の設定はあるが、会社が選択されていない場合は、選択肢を表示しない
                if (companySelect.find('option:selected').length > 0 && companySelect.find('option:selected').val() !== '') {
                    setSelect(companySelect, 'select.company-vehicle-select', { 'company_id': companySelect.val() });
                } else {
                    clearSelect(companyVehicleSelect, 'select.company-vehicle-select');
                }
            } else {
                setSelect(companyVehicleSelect, 'select.company-vehicle-select');
            }
         }
     });

    /*---- 営業所で絞り込む ----*/

    // 営業所で絞り込むチェックボックス押下
    $(document).on('click', 'input[name^="select_filter_section"]', function () {
        selectFilterSection($(this));
    });

    /*---- アカウント未設定ユーザーのセレクト設定時 ----*/

    // セレクト設定時
    $(document).on('change', 'select.account-user-select', function () {
        setMultiSelected(this, 'select.group-select', {'user_id': $(this).val()})
    });

    /*---- 会社のセレクト設定時 ----*/

    // セレクト設定時
    let belongingProcessFlag = false;
    let instructionProcessFlag = false;
    $(document).on('change', '.rollcall-setting-rollcall-type, .rollcall-company-authorizer-select, #rollcall-setting-modal-user_id', function () {
        const companySelect = $(this).parents('form').find('.company-select')[0];
        const sectionSelect = $(this).parents('form').find('.section-select')[0];
        if (!$(this).hasClass('rollcall-company-authorizer-select')) {
            if (belongingProcessFlag) return;
            belongingProcessFlag = true;
            setMultiSelect(companySelect, 'select.belonging-multiple-select', {
                'rollcall_type': (
                    ($(this).parents('form').find('input[name="rollcall_type"]:checked').length) ?
                        $(this).parents('form').find('input[name="rollcall_type"]:checked').val() :
                        $(this).parents('form').find('input[name="rollcall_type"]').val()
                ),
                'default_belongings': $(this).parents('form').find('select[name="belongings[]"]').data('default-belongings'),
            }, function(companySelect, select, values) {
                $.each(values, function(i, value) {
                    $(select).multipleSelect('check', value);
                });
            });
        }
        if (instructionProcessFlag) return;
        instructionProcessFlag = true;
        setMultiSelect(sectionSelect, 'select.instruction-multiple-select', {
            'section_id': $(this).val(),
            'authorizer_id': $(this).parents('form').find('select[name="authorizer_id"]').val(),
            'rollcall_type': (
                ($(this).parents('form').find('input[name="rollcall_type"]:checked').length) ?
                    $(this).parents('form').find('input[name="rollcall_type"]:checked').val() :
                    $(this).parents('form').find('input[name="rollcall_type"]').val()
            ),
            'user_id': $(this).parents('form').find('select[name="user_id"]').val(),
            'default_instructions': $(this).parents('form').find('select.instruction-multiple-select').data('default-instructions'),
            'display_type': $(this).parents('form').find('select.instruction-multiple-select').data('display-type'),
            'with_trashed': $(this).parents('form').find('select.instruction-multiple-select').data('with-trashed')
        }, function(companySelect, select, values) {
            $.each(values, function(i, value) {
                $(select).multipleSelect('check', value);
            });
        });
        setTimeout(function() {
            belongingProcessFlag = false;
            instructionProcessFlag = false;
        }, 100);
    });

    // 乗務員のみのチェックボックス押下
    $(document).on('click', '#input-is-driver-only', function () {
        const company_id =$('select.company-select').find('option:selected').val();
        if(company_id === ''){
            return;
        }

        let form = 'select.driver-select';
        let elm = $('select.section-select');
        if ($('.company-driver-select').length > 0) {
            elm = $('select.company-select');
            form = 'select.company-driver-select';
        }

        const $checkbox = $('#input-is-driver-only');
        let param = {};

        if(!$(this).prop('checked')){
            setSelect(elm,form,param);
        }
        else{
            param.type = 'driver';
            setSelect(elm,form,param);
        }

    });

    // // セレクト２設定時
    // TODO: 重複してchangeイベントが発生しているためセレクト２のイベント変更は無視する
    // $(document).off('select2:selecting', '.select2');
    // $(document).on('select2:selecting', '.select2', function (e) {
    //     $(this).val(e.params.args.data.id);
    // });

     /**
      * select multiple の検索機能
      */
     // multiple検索エリアのイベント発火無効処理
     $(document).on('change', '.select-multiple--search-text input', function() {
         return false;
     });
     // multiple検索はkeyupで発火
     $(document).on('keyup', '.select-multiple--search-text input', function() {
         let select = $(this).parent('.select-multiple--search-text').siblings('select');
         let search = $(this).val();
         select.find('option').removeClass('d-none');
         if (search.length > 0) {
             select.find('option').filter(function(idx){
                 return $(this).text().indexOf(search) < 0;
             }).addClass('d-none');
         }
     });
     // option selected toggle制御
     $(document).on('mousedown', '.select-multiple--select option', function(e) {
         let self = $(this);
         let select = self.parent('select');
         if (e.shiftKey) {
             // (+shiftKey)複数指定の時は範囲指定でselectedする
             let options = select.find('option');
             let from, to;
             if (self.index() > select.find('option:selected').last().index()) {
                 from = select.find('option:selected').last().index();
                 to = self.index();
             } else {
                 from = self.index();
                 to = select.find('option:selected').last().index();
             }
             options.each(function(idx){
                 if (idx >= from && idx <= to) {
                     $(this).prop("selected", true);
                 }
             });
         } else {
             if (self.prop("selected")) {
                 self.prop("selected", false);
             } else {
                 self.prop("selected", true);
             }
         }
         select.trigger('change');
     });
     // multiple 選択解除
     $(document).on('click', '.select-multiple--label .select-reset', function() {
         let select = $(this).parent('.select-multiple--label').siblings('select');
         select.find('option').prop('selected', false);
         select.trigger('change');
     });

     // select-multiple--fold-select-panel focus, blurの表示・非表示制御
    $(document).on('focus', 'div.select-multiple--fold-select-panel-container input', function () {
        $(this).parents('div.select-multiple--fold-select-panel-container').find('select.select-multiple--fold-select-panel').show();
    });
    $(document).on('blur', 'div.select-multiple--fold-select-panel-container input', function (e) {
        const parent = $(this).parents('div.select-multiple--fold-select-panel-container');
        if(false == $(e.relatedTarget).hasClass('select-multiple--fold-select-panel')) {
            parent.find('select.select-multiple--fold-select-panel').hide();
        }
        let showText = '';
        parent.find('option:selected').each(function(i, elem) {
            if(showText.length > 0)
                showText += ",";
            showText += $(elem).text();
        })
        $(this).val(showText);
    });


});
